interface SVGProps {
  style: React.CSSProperties;
  color: string;
}

const SVG = (props: SVGProps) => {
  const { color } = props;

  return (
    <svg style={props.style} xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
      <path
        d="M16.7485 31.623L6.12604 21.0005L16.7485 10.378"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M35.875 21L6.4225 21" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default SVG;
